import Form from '@bluheadless/ui-logic/src/components/form/form'
import { LOCALSTORAGE_KEY_GUEST_ORDERS, PAGE_PATH_GUEST_ORDER_DETAIL } from '@bluheadless/ui-logic/src/constants'
import { getTomorrowDate } from '@bluheadless/ui-logic/src/utils/date'
import { useCustomerGuestOrderValidate } from '@bluheadless/ui-logic/src/hooks/customer/useCustomerGuestOrderValidate'
import { useFormFields } from '@bluheadless/ui-logic/src/hooks/form/useFormFields'
import { useLocalStorage } from '@bluheadless/ui-logic/src/hooks/useLocalStorage'
import { useNotification } from '@bluheadless/ui-logic/src/hooks/useNotification'
import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { cx } from '@emotion/css'
import { yupResolver } from '@hookform/resolvers/yup'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/system'
import router from 'next/router'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { object as yupObject } from 'yup'
import SubmitButton from '../../../molecules/button/submit-button'
import { ControlledInput } from '../../../molecules/input'
import { Root, Title } from './order-form.styled'

const GuestOrderForm = ({ className, formProps }) => {
	const theme = useTheme()
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const { formatMessage } = useIntl()
	const { action: guestOrderAction } = useCustomerGuestOrderValidate()
	const { enqueueNotification } = useNotification()
	const { groupId } = useStore()
	const [storageValue, setStorageValue] = useLocalStorage(`${LOCALSTORAGE_KEY_GUEST_ORDERS}_${groupId}`, [])

	const { orderEmail, orderNumber } = useFormFields()

	const schemaDefault = yupObject().shape(
		{
			[orderNumber.name]: orderNumber.validation,
			[orderEmail.name]: orderEmail.validation,
		},
		[]
	)

	const handleSubmit = useCallback(
		async (formData) => {
			try {
				const order = await guestOrderAction({
					number: formData.order_number,
					email: formData.order_email,
				})

				setStorageValue(
					[
						...storageValue.filter(({ orderNumber }) => orderNumber !== order.number),
						{
							orderNumber: order.number,
							orderId: order.id,
							protectCode: order.protectCode,
							email: order.email,
						},
					],
					getTomorrowDate()
				)
				router.push(PAGE_PATH_GUEST_ORDER_DETAIL + order.number)
			} catch (err) {
				enqueueNotification({ uiProps: { severity: 'error', message: formatMessage({ id: 'guest_order_not_found' }) } })
			}
		},
		[enqueueNotification, guestOrderAction, setStorageValue, storageValue, formatMessage]
	)

	return (
		<Root className={cx('GuestOrder-root', className)}>
			<Title component="h1" variant={lgUp ? 'h4' : 'h1'}>
				{formatMessage({ id: 'guest_order_title' })}
			</Title>
			<Form
				onSubmit={handleSubmit}
				options={{
					resolver: yupResolver(schemaDefault),
				}}
				{...formProps}
			>
				<ControlledInput name={orderNumber.name} id="order_number" label={orderNumber.label} required />
				<ControlledInput name={orderEmail.name} id="order_email" label={orderEmail.label} required />
				<SubmitButton fullWidth label={formatMessage({ id: 'guest_order_submit' })} />
			</Form>
		</Root>
	)
}

export default GuestOrderForm
